'use strict';
import Component from '../core/component';

/**
 *
 */
class If extends Component {
    state = {}
    
    
    render() {
        if (this.props.show)
            return this.props.children
        return null;
    }
}

If.displayName = "If";
export default If
